import { useRouter } from 'vue-router/composables'
export const useRouterComposable = () => {
  const router = useRouter()

  const pushRouter = (routerObject) => {
    router.push(routerObject).catch(() => {})
  }

  const replaceRouter = (routerObject) => {
    router.replace(routerObject).catch(() => {})
  }

  const routerBack = () => {
    router.back()
  }

  return {
    pushRouter,
    replaceRouter,
    routerBack,
  }
}
